module.exports = __webpack_public_path__ + "static/media/Google_Play_Menu.7fe966b8.svg";